import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { useDispatch, useSelector } from "react-redux";
import { hideSnackbar } from "../../store/snackbar/slice";

const Alert = MuiAlert as React.ElementType;

const SnackbarNotifier = () => {
  const dispatch = useDispatch();
  const { open, message, severity } = useSelector(
    (state: any) => state.snackbar
  );

  const handleClose = () => {
    dispatch(hideSnackbar());
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={4000}
      onClose={handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      sx={{ mt: 4 }}
    >
      <Alert severity={severity} variant="filled" onClose={handleClose}>
        {message}
      </Alert>
    </Snackbar>
  );
};

export default SnackbarNotifier;
